import React from "react";
import { Loading } from "../../components/Loading";
import { Header } from "../../components/Header";
import { Table } from "antd";
import useMessageReport from "../../hooks/useMessagesReport";
import { ContentCard } from "../../components/ContentCard/ContentCard";
import FilterMessagesReport from "./FilterMessagesReport.jsx/FilterMessagesReport";
export const MessagesReport = () => {
  const {
    loading,
  } = useMessageReport();

  const { Column } = Table;
  return (
    <Loading isLoading={loading}>
      <Header
        title="گزارش پیام ها "
        activeItem="MessagesReport"
        leftTitle={
          <div>
            <span>تعداد کل پیام ها : 0</span>
            <span></span>
          </div>
        }
      />
      <ContentCard filter={<FilterMessagesReport />}>
        <Table
          size="small"
          scroll={{ x: 640 }}
          // dataSource={products}
          // pagination={{
          //   position: ["bottomCenter"],
          //   current: pagination.page,
          //   pageSize: pagination.limit,
          //   total: pagination.count,
          //   onChange: changePage,
          // }}
        >
          <Column title="ردیف" />
          <Column title="استان" />
          <Column title="شهر" />
          <Column title="نام خودرو" />
          <Column title="پلاک خودرو" />
          <Column title="شماره راننده" />
          <Column title="نام راننده" />
          <Column title="نام و نام خانوادگی کاربر" />
          <Column title="تعداد روز تاخیر در خرید" />
          <Column title="تعداد روز تاخیر در مراجعه" />

          <Column title="کیلومتر بعدی" />
          <Column title="کیلومتر تاخیر در مراجعه" />
        </Table>
      </ContentCard>
    </Loading>
  );
};
